import { DECK_COPY_LIMIT_EXCEPTIONS } from '../constants/deckCopyRules';
import { DECK_LIMITS } from '../types/deck';

/**
 * Soft ceiling used when a card allows any number of copies.
 * Zone size checks remain the real binding constraint.
 */
export const UNLIMITED_COPY_SOFT_CAP =
  DECK_LIMITS.MAIN_DECK_SIZE + DECK_LIMITS.SIDEBOARD_MAX;

/** Max copies of this card name allowed across champion + main + sideboard. */
export function maxCopiesForCardName(name: string): number {
  const exception = DECK_COPY_LIMIT_EXCEPTIONS.get(name.trim());
  if (!exception) return DECK_LIMITS.MAX_COPIES;
  if (exception.kind === 'unlimited') return UNLIMITED_COPY_SOFT_CAP;
  return exception.max;
}

export function isUnlimitedCopyCard(name: string): boolean {
  return DECK_COPY_LIMIT_EXCEPTIONS.get(name.trim())?.kind === 'unlimited';
}

/** True when `count` already meets or exceeds the per-name cap (cannot add more). */
export function isAtCopyLimit(name: string, count: number): boolean {
  return count >= maxCopiesForCardName(name);
}

/** True when `count` is over the per-name cap (validation error). */
export function exceedsCopyLimit(name: string, count: number): boolean {
  return count > maxCopiesForCardName(name);
}
